import { IInvoice, IInvoiceResponseSave } from "@/core/model/sys/IInvoice";
import BaseService from "../base/BaseService";
import IParamServices from "../IParamServices";
import { eDiscounType, eInvoiceClass, eInvoiceRel, eInvoiceStatus } from "@/core/model/GloblasEnum";
import { ICurrency } from "@/core/model/sys/ICurrency";
import { IProduct } from "@/core/model/sys/IProduct";
import { IInvoiceDetail } from "@/core/model/sys/IInvoiceDetail";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IContract } from "@/core/model/sys/IContract";
import { IPagedParameters, IPagedResult } from "@/core/model/sys/IPagedParameters";
import { IInvoicePayment, IPaymentMethod } from "@/core/model/sys/IInvoicePayment";
import { ICustomer } from "@/core/model/sys/ICustomer";

export default class InvoiceService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public newInvoice(type:eInvoiceClass,rel:eInvoiceRel,gid:any, currency:ICurrency|null):IInvoice
  {
    const hoy = new Date();
    hoy.setDate(hoy.getDate() + 30);
    return {
      Gid:this.NewId,
      Status: eInvoiceStatus.Vigente,
      Customer: null,
      Currency: currency,
      InvoiceClassId:type,
      InvoiceClass:{
        InvoiceClassId: type,
        Code: '',
        Index: 0,
        Active: true
      },
      Code:'',
      Quantity:0,
      Subtotal:0,
      Total:0,
      DiscountAmount:0,
      ModifiedBy: 0,
      ModifiedByEmployee: null,
      EmitedDate: new Date(),
      LimitPaymentDate: hoy,
      ModifiedTime: new Date(),
      InitialPeriod:null,
      FinalPeriod:null,
      FullfiedBy: 0,
      FullfiedTime:new Date(),
      FullfiedByEmployee: null,
      Comments:'',
      InvoiceRel:rel,
      SecondaryId:gid,
      Version: 0,
      Active:true,
      IsNew:true,
      Detalle:[],
      Payments:[],
      InvoiceBalance:null,
      ExtensionInvoice:null,
      Contract:null,
      ErrorSave:false,
      Error: ''
    };
  }
  public newInvoicePayment(invoice:IInvoice|null):IInvoicePayment
  {
    return {
      Gid: this.NewId,
      Invoice:invoice,
      PaymentMethod:null,
      PaymentDate:new Date(),
      Amount:0,
      IsApproved:true,
      Active:true,
      Deleted:false,
      IsNew:true,
      ErrorSave:false,
      Error:''
    };
  }
  public toInviceDetail(product:IProduct):IInvoiceDetail
  {
    const p:any ={...product};
    p.ProductType = product.ProductType.ProductType;
    return {
      Gid: this.NewId,
      Product: p,
      Subtotal: product.Price,
      Total: product.Price,
      PrecioModificado:false,
      DiscountType: eDiscounType.None,
      DiscountPercent:0,
      DiscountAmount:0,
      Quantity:1,
      ListPrice:product.Price,
      Price:product.Price,
      Comentarios:'',
      Active:true,
      IsNew:true,
      Deleted: false
    }
  }
  public async GetInvoice(gid:any): Promise<IInvoice|null>
  {
    let response:IServiceResponse|null = null;
    response = await this.Get('IndexInvoice/GetInvoice/' + gid,null,null,null,true,false,null);
    if(response && response.Response)
    {            
      return response.Response;
    }
    return null;
  }
  public async GetInvoicePdf(gid:any): Promise<IServiceResponse|null>
  {
    let response:IServiceResponse|null = null;
    response = await this.Get('IndexInvoice/GetInvoicePdf/' + gid,null,null,null,true,undefined,'arraybuffer' );
    return response;
  }
  public changeInvoiceClass(invoice:IInvoice,product?:IProduct|undefined|null):IInvoice
  {
    if(invoice && product)
    {
      if(invoice.InvoiceClass?.InvoiceClassId === eInvoiceClass.RM && invoice.InitialPeriod && invoice.FinalPeriod)
      {
        if(invoice.Detalle && invoice.Detalle.length == 1)
        {
          if(invoice.Detalle[0].Product?.Gid === product.Gid)
          {
            if(invoice.InvoiceClass?.InvoiceClassId === eInvoiceClass.RM && invoice.InitialPeriod && invoice.FinalPeriod)
            {
              invoice.InvoiceClass.InvoiceClassId = eInvoiceClass.RAM;
            }  
          }            
        }        
      } 
    }
    return invoice
  }
  public async SaveInvoice(invoiceData:IInvoice) : Promise<IInvoice>
  {        
    let response:IServiceResponse|null = null;
    const invoice = {...invoiceData};     
    response = await this.Post('IndexInvoice/SaveInvoice',invoice,null,null,null,true,false,null);
    if(!response)
    {
      invoice.ErrorSave = true;
      invoice.Error = 'Ocurrio un error al generar el recibo';
    }    
    if(response && response.Response)
    {      
      if(response.Response.Error)
      {
        invoice.ErrorSave = true;
        invoice.Error = response.Response.Response;  
      }
      else
      {
        invoice.Code = response.Response.InvoiceDto? response.Response.InvoiceDto.Code:'';
        invoice.ErrorSave = false;
        invoice.Error = ''; 
      }
    }
    return invoice;
  }
  public async AddPayment(invoicePaymentData:IInvoicePayment) : Promise<IInvoicePayment>
  {        
    let response:IServiceResponse|null = null;
    const invoicePayment = {...invoicePaymentData};    
    response = await this.Post('IndexInvoice/AddPayment',invoicePayment,null,null,null,true,false,null);
    if(response && response.Response)
    {
      if(response.Response.Error)
      {
        invoicePayment.ErrorSave = true;
        invoicePayment.Error = response.Response.Response;  
      }
      else
      {
        invoicePayment.ErrorSave = false;
        invoicePayment.Error = ''; 
      }
    }
    else
    {
      invoicePayment.ErrorSave = true;
      invoicePayment.Error = 'Ocurrio un error al generar el pago ' + this.NoResponse;       
    }    
    return invoicePayment;
  }
  public async QuickSearchInvoiceContract(paged:IPagedParameters,contract:IContract,filter:string,rel:eInvoiceRel):Promise<IPagedResult<IInvoice>>
  {    
    const result: IPagedResult<IInvoice> = {
      Paged:null,
      Result:[]
    }  
    const filters = {
      Page: paged.Page,
      InvoiceRel:rel,
      SecondaryId: contract.Gid,
      Search: filter
    }        
    const response:IServiceResponse = await this.Post('IndexInvoice/QuickSearchInvoicePaged',filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
    }                
    return result;
  }
  public async QuickSearchInvoiceCustomer(paged:IPagedParameters,customer:ICustomer,filter:string,rel:eInvoiceRel):Promise<IPagedResult<IInvoice>>
  {    
    const result: IPagedResult<IInvoice> = {
      Paged:null,
      Result:[]
    }  
    const filters = {
      Page: paged.Page,
      InvoiceRel:rel,
      SecondaryId: customer.Gid,
      Search: filter
    }        
    const response:IServiceResponse = await this.Post('IndexInvoice/QuickSearchInvoicePaged',filters,null,null,null,true,false,null); 
    if(response)
    {
      result.Paged = response.Paged;
      result.Result = response.Response? response.Response:[];
    }                
    return result;
  }
  public async ListPaymentMethod():Promise<IPaymentMethod[]>
  {
    const result = Array<IPaymentMethod>();
    const response:IServiceResponse = await this.Get('IndexInvoice/ListPaymentMethod',null,null,null,true,false,null);  
    if(response.Response)
    {      
      for (const element of response.Response)
      {       
        result.push({...element});  
      }
    }    
    return result;
  }
  public async GetProductAguaService():Promise<IProduct|null>
  {    
    const response:IServiceResponse = await this.Get('IndexInvoice/GetProductAguaService',null,null,null,true,false,null);  
    if(response.Response)
    {      
      return response.Response;
    }    
    return null;
  }
  public async SearchInvoicePeriod(contract:IContract,ini:Date,fin:Date):Promise<IInvoiceResponseSave|null>
  {        
    const filters = {
      ContractId: contract.Gid,
      Ini:ini,
      Fin:fin
    }        
    const response:IServiceResponse = await this.Post('IndexInvoice/SearchInvoicePeriod',filters,null,null,null,true,false,null); 
    if(response && response.Response)
    {      
      return response.Response;
    }
    return null;
  }
}